import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: '[app-gtag]',
    template: '',
    standalone: true,
})
export class GtagComponent {
    private trackingCode = environment.gtagId;

    constructor(
        @Inject(PLATFORM_ID) private readonly platformId: Object,
        private readonly renderer: Renderer2,
        private readonly el: ElementRef,
    ) {
        // BROWSER
        if (isPlatformBrowser(this.platformId) && this.trackingCode) {
            let scriptBody;
            const script = this.renderer.createElement('script') as HTMLScriptElement;

            if (!environment.production) {
                scriptBody = this.renderer.createText(`
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=Mtg9WFY17AjEYRXrLDhtIg&gtm_preview=env-3&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${this.trackingCode}')
                `);
            } else {
                scriptBody = this.renderer.createText(`
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=cMt0pMoTCw19sfjM7kftvQ&gtm_preview=env-1&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${this.trackingCode}');
                `);
            }

            this.renderer.appendChild(script, scriptBody);
            script.async = true;
            script.id = 'gtm-platform-container';
            this.renderer.appendChild(this.el.nativeElement, script);

            const script2 = this.renderer.createElement('script') as HTMLScriptElement;
            const script2Body = this.renderer.createText(`
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    dataLayer.push(arguments);
                }
                gtag('js', new Date());

                gtag('config', '${this.trackingCode}');
            `);
            this.renderer.appendChild(script2, script2Body);
            this.renderer.appendChild(this.el.nativeElement, script2);
        }
    }
}